<script lang="ts" setup>
import {
  frameCss,
  frameJs,
  H5PContentConfig,
  H5PEvent,
  H5PStandaloneOptions,
} from "@/models/h5p.model";
import { H5pRest } from "@/services/rest/h5p.rest";
import { H5P as H5PStandalone } from "h5p-standalone";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

declare global {
  interface Window {
    H5P: any;
    H5PIntegration: H5PContentConfig;
    jQuery?: any;
  }
}

const BASE = "/h5p";
import { useCourseStudentStore } from "@/store/course-student";
const storeCourse = useCourseStudentStore;
const h5pid = storeCourse.getH5pId;
const loading = ref(true);
const route = useRoute();
const router = useRouter();

function url(path: string) {
  return `${BASE}/${path}${h5pid}`;
}

function finishUserData(): void {
  window.H5P.externalDispatcher.on("xAPI", (event: H5PEvent) => {
    const verbId: string = event?.data?.statement?.verb?.id;
    if (verbId.includes("answered") || verbId.includes("completed")) {
      setTimeout(() => sendUserData(), 1000);
    }

    if (verbId.includes("answered")) {
      setTimeout(() => sendUserDataResult(event), 1000);
    }
  });
}

async function getUserData(
  element: HTMLElement | null,
  options: H5PStandaloneOptions
): Promise<void> {
  await H5pRest.getUserData(h5pid, String(route.params.id))
    .then((response) => {
      options.contentUserData = response;
    })
    .catch(() => router.push({ name: "dashboardStd" }));

  await new H5PStandalone(element, options);
}

function sendUserData(): void {
  const { contents } = window.H5PIntegration;
  let { contentUserData } = contents[`cid-${h5pid}`];

  H5pRest.sendUserData(String(h5pid), String(route.params.id), contentUserData);
}

function sendUserDataResult(event: H5PEvent): void {
  const { result, object } = event?.data?.statement;
  const data = {
    h5pId: h5pid,
    chapterId: object?.id?.split("=").pop() || "",
    courseId: String(route.params.id),
    maxScore: result?.score?.max || 0,
    raw: result?.score?.raw || 0,
  };
  if (!result) return;
  H5pRest.sendQuizData(data);
}

async function getH5P(): Promise<void> {
  loading.value = true;
  const el = document.getElementById("h5p-container");
  const options: H5PStandaloneOptions = {
    id: String(h5pid),
    h5pJsonPath: url(""),
    contentJsonPath: url("content/"),
    librariesPath: process.env.VUE_APP_H5P_URL,
    frameJs,
    frameCss,
    saveFreq: 1,
  };

  await getUserData(el, options);
  loading.value = false;
  finishUserData();
}

onMounted(() => {
  if (route.params.h5pId) storeCourse.setH5pId(route.params.h5pId as string);
  setTimeout(() => getH5P(), 200);
});
</script>

<template>
  <section>
    <Loader
      v-if="loading"
      :loader="loading"
      label="Carregando..."
      loaderType="progress"
    />

    <div id="h5p-container" class="my-10"></div>
  </section>
</template>
